module.exports = __webpack_public_path__ + "img/13.33a6e39a.png";